<template>
  <div class="theme--light v-card pa-4 cbg-white-container">
    <v-row>
      <v-col cols="12" md="6" sm="6" class="input-container">
        <v-row>
          <v-col cols="12" md="6" sm="6" class="form-group">
            <label for class="fz-10px">Search</label>
            <div class="search-div position-relative">
              <input
                class="form-control"
                v-model="search"
                placeholder="Search"
                @keyup="getReleaseList()"
              />
              <div
                v-if="search !== ''"
                class="search-svg"
                @click="clearSearch()"
              >
                <crossSVG />
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <label>Platform</label>
            <v-select
              v-model="platform"
              :items="items"
              placeholder="Select Platform"
              required
              name="userProfile"
              outlined
              hide-details
              @change="getReleaseList()"
            ></v-select>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="6" sm="6" class="d-flex justify-end mt-6">
        <v-btn class="btn btn-primary mr-4 px-6 py-5" @click="getView()">Create New Release</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="table-div">
          <table class="table table-responsive">
            <thead>
              <tr class="table-success">
                <th scope="col">Name</th>
                <th scope="col">Version</th>
                <th scope="col">Date</th>
                <th scope="col">Platform</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody v-if="!isEmpty">
              <tr v-for="(items, i) in releaseList" :key="i">
                <td>
                  <div>
                    {{ items.release_name }}
                  </div>
                </td>
                <td>
                  <div>
                    {{ items.release_version }}
                  </div>
                </td>
                <td>
                  <div>{{items.release_date | formatDate  }} </div>
                </td>
                <td>
                  <div class="d-flex align-center justify-space-between">
                    <span class="ww-50"> {{ items.platform }}</span>
                    <v-btn class="btn btn-primary ml-3 px-6 py-3" @click="getView(items._id,'view')">View</v-btn>
                  </div>
                </td>
                <td class="action-div">
                  <div>
                    <CDropdown color="link" size="lg" :caret="false">
                      <template #toggler-content>
                        <verticalDotsSVG class="ww-20" />
                      </template>
                      <CDropdownItem class="border-bottom p-clr" @click="getView(items._id,'edit')">Edit</CDropdownItem>
                      <CDropdownItem class="border-bottom p-clr" @click="deleteRelease(items._id)">Delete</CDropdownItem>
                      <CDropdownItem class="p-clr" @click="getView(items._id,'create')">Clone Feature</CDropdownItem>
                    </CDropdown>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr v-if="isEmpty">
                <td colspan="6">
                  <h2 class="text-center mt-4">No Data Found</h2>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-col>
    </v-row>
    <v-dialog persistent v-model="newFeatureModal" scrollable width="600">
      <newFeatureModal @close="newFeatureModal = false" />
    </v-dialog>
  </div>
</template>
<script>
import config from "@/config.js";
const newFeatureModal = () => import("@/components/modals/newFeatureModal");
import { pickSvg } from "@/views/SVG";
import dayjs from "dayjs";
export default {
  data() {
    return {
      platform:'All',
      search: "",
      isEmpty: false,
      newFeatureModal: false,
      items: ["All","Web", "Android","IOS"],
      releaseList:[]
    };
  },
  components: {
    newFeatureModal,
    ...pickSvg("crossSVG", "verticalDotsSVG"),
  },
  mounted(){
    this.getReleaseList()
  },
  filters: {
    formatDate: (date) => {
      return dayjs(date).format("DD/MM/YYYY");
    },
  },
  methods: {
    clearSearch() {
      this.search = "";
    },
    getView(id,type) {
      this.$router.push({
        name: "ReleaseData",
        params: { id ,type}
      });
    },
    deleteRelease(id) {
      let url = `${config.BASE_URL}api/v2/admin/delete-release/${id}`;
      this.$http.delete(url).then(response => {
        this.getReleaseList();
      });
    },
    getReleaseList(){
      let url = `${config.BASE_URL}api/v2/admin/version-release?platform=${this.platform}&search=${this.search}`;
      this.$http.get(url).then(response => {
        this.releaseList = response.data.data.list
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.ww-50 {
  width: 50px;
}
.action-div{
 .dropdown-menu{
    padding:0px!important;
    }
}

</style>
